var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"text-center mt-5"},[_vm._v("You are not allowed to view this page")])
}
var staticRenderFns = []

export { render, staticRenderFns }